/** eslint-disable react-hooks/exhaustive-deps */
import { createContext as reactCreateContext, useMemo, useContext as reactUseContext } from "react"

export function createContext<ContextValueType extends object>(rootComponentName: string) {
  const Context = reactCreateContext<ContextValueType | undefined>(undefined)

  const Provider = (props: ContextValueType & { children: React.ReactNode }) => {
    const { children, ...providerProps } = props

    // Only re-memoize when prop values change
    const value = useMemo(() => providerProps, Object.values(providerProps)) as unknown as ContextValueType

    return <Context.Provider value={value}>{children}</Context.Provider>
  }

  function useContext(consumerName: string) {
    const context = reactUseContext(Context)

    if (context === undefined) {
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``)
    }

    return context
  }

  Provider.displayName = `${rootComponentName}Provider`

  return [Provider, useContext] as const
}
